import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  message: PropTypes.string,
  small: PropTypes.string,
};

const Lead = (props) => (
  <b onClick={props.onClick} className="lead">
    {props.message} { props.onClick && (<a><i className="fa fa-question-circle"></i></a>) }
    <small id="from">{props.small && props.small}</small>
  </b>
);
Lead.propTypes = propTypes;
export default Lead;
